import { BookCheck, Home, History, TvMinimalPlay, Images, Rss, ImagePlus, SquareTerminal, Inbox, Calendar1 } from "lucide-react";
import NavButton from "./NavButton";
import { AuthContext, AuthContextType } from "../context";
import { useContext } from "react";
import { useAtomValue } from "jotai";
import { themeAtom } from "../atoms/theme-atoms";

const NavSidebar = () => {

  const { isPlayground, username } = useContext<AuthContextType>(AuthContext)

  const themes = useAtomValue(themeAtom)

  return (
    <div className="w-16  z-50 pt-1 pb-2  h-[95vh] mt-[5vh] rounded-xl  flex-col items-center justify-center hidden sm:flex">
      <p></p>
      <div className="flex flex-col gap-4 text-gray-500 w-full p-1 border border-gray-300 bg-white/30 bg-white bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-10 rounded-xl">
        {!isPlayground && (
          <>
            {/*
            <NavButton icon={<MessageSquareHeart size={22} color="gray" />} routeTo="/home/threads" description="siAi Threads" name="Threads" />
            */}

            <NavButton icon={<Home size={22} />} routeTo="/home?curr=navigation" description="Home" name="Home" searchValue="navigation" />
            {themes.showRecommend &&
              <NavButton icon={<Rss size={22} />} routeTo="/home?curr=first" description="Review" name="Review" searchValue="first" />
            }
              <NavButton icon={<Calendar1 size={22} />} routeTo="/home?curr=campaign" description="Brand Campaigns" name="Brand Campaigns" />
            <NavButton icon={<Images size={22} />} routeTo="/home/gallery" description="Image Gallery" name="Gallery" />
            {themes.isClient &&
              <>
                <NavButton icon={<BookCheck size={22} />} routeTo="/home/approve/2" description="Your workflow lineup" name="Scheduled" />
                <NavButton icon={<History size={22} />} routeTo="/home/previous" description="Posted and Discarded Posts" name="Look Back" />
              </>
            }
          </>
        )}
        {(username === "testuser") && (
          <>
            <NavButton icon={<ImagePlus size={22} />} routeTo="/home/_admin/gallery-approve" description="Admin Gallery" name="Admin Gallery" />
            <NavButton icon={<SquareTerminal size={22} />} routeTo="/home/_admin/admin-conf" description="Admin Config" name="Admin Config" />
            <NavButton icon={<Inbox size={22} />} routeTo="/home/_admin/feedback" description="Feedback" name="Feedback" />
          </>
        )}
        {isPlayground &&
          <NavButton icon={<TvMinimalPlay size={22} />} routeTo="/home/play" description="Playground" name="Playground" />
        }
        {/*
          <NavButton icon={<Settings size={22} />} routeTo="/home/settings" description="Settings" name="Customize" />
        */}
      </div>
      <p></p>
    </div>
  )
}

export default NavSidebar;
